import { render, staticRenderFns } from "./introduction-dialog.vue?vue&type=template&id=08c82d4d&scoped=true&"
import script from "./introduction-dialog.vue?vue&type=script&lang=js&"
export * from "./introduction-dialog.vue?vue&type=script&lang=js&"
import style0 from "./introduction-dialog.vue?vue&type=style&index=0&id=08c82d4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c82d4d",
  null
  
)

export default component.exports